import List from './list/SaleChannels';
import Edit from './edit/EditSaleChannel';
import Create from './create/CreateSaleChannel';
import Individual from './individual/SaleChannel';

export default { List, Edit, Create, Individual }